var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"vertical"}),_c('span',{staticClass:"grey--text"},[_c(_vm.component,{tag:"component",attrs:{"message":_vm.message}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }